module.exports = __webpack_public_path__ + "img/icon02.f8006f08.png";